import AccountProvider from '@maas-tools/accounts'
import { useMaasKeycloak } from '@maas-tools/keycloak'
import { BrowserRouter } from 'react-router-dom'
import {
  ACCOUNT_API_URL,
  FLAG_ENABLE_REDIRECT_SHELL,
  SHELL_PUBLIC_URL,
} from 'core/common/constants/env'
import AppLoading from 'core/containers/App/AppLoading'
import AppPermission from 'core/containers/App/AppPermission'
import AppShell from 'core/containers/App/AppShell'
import AppToken from 'core/containers/App/AppToken'
import AppExport from 'magalu/AppExport'

const App = () => {
  if (FLAG_ENABLE_REDIRECT_SHELL === 'true') {
    window.location.href = `${SHELL_PUBLIC_URL}/products`
  }

  const { keycloak, initialized } = useMaasKeycloak()

  if (!initialized) {
    return null
  }

  const config = {
    url: ACCOUNT_API_URL,
    keycloakToken: keycloak.token,
  }

  return (
    <AccountProvider LoadingComponent={<AppLoading />} config={config}>
      <AppPermission>
        <AppToken>
          <BrowserRouter>
            <AppShell>
              <AppExport />
            </AppShell>
          </BrowserRouter>
        </AppToken>
      </AppPermission>
    </AccountProvider>
  )
}

export default App
